<template>
    <div>
        <div>
            <Button v-if="displayedCurrentDepartment" :label="displayedCurrentDepartment" :badge="departmentCount > 1 ? departmentCount : null" class="m-2 p-button w-full text-left" v-tooltip="'Show details'" @click="displayDeptDetails = true" />
            <div v-else>Departments not available</div>
        </div>
        <!-- department details -->
        <UserDepartmentsDetailsDialog v-if="displayDeptDetails" :departments="currentDepartments" @hide-dialog="displayDeptDetails = false" />
    </div>
</template>

<script setup>
import UserDepartmentsDetailsDialog from './UserDepartmentsDetailsDialog.vue';
import { ref, onMounted, computed } from 'vue';

import { departmentStore } from '../../../../../store/global-stores';
const props = defineProps({
    userId: {
        type: Number,
    },
});
// console.log
const currentDepartments = ref([]);
const displayDeptDetails = ref(false);

const departmentCount = computed(() => {
    return currentDepartments.value.length.toString();
});

const displayedCurrentDepartment = computed(() => {
    let deptString = null;
    if (currentDepartments.value.length > 0) {
        deptString = currentDepartments.value[0]?.name;
    }
    if (deptString) {
        // stringify
        deptString = JSON.stringify(deptString);
        // check length
        deptString = deptString.length > 20 ? deptString.slice(0, 25) + '.."' : deptString;
    }
    return deptString?.replace(/"/g, '');
});

onMounted(() => {
    // load department
    loadDepartment();
});

const loadDepartment = async () => {
    currentDepartments.value = await departmentStore.fetchUserDepartments(props.userId);
};
</script>
